import { type DataLayerCallbackProps } from '@dhl/datalayer'
import { type DataLayerData, type DataLayerEventPurchase, type DataLayerMeta } from '../types/types.js'
import { type AdobePurchaseEvent } from './types.js'
import { getDefaultMetaAttributes } from './getDefaultMetaAttributes.js'

export const writePurchaseEvent = (dataLayerEvent: DataLayerCallbackProps<DataLayerData, DataLayerMeta>): void => {
  const { purchase } = dataLayerEvent.meta as DataLayerEventPurchase

  const data: AdobePurchaseEvent = {
    event: 'dhl_utf_purchase',
    purchase,
    attributes: {
      ...getDefaultMetaAttributes(dataLayerEvent.data),
    },
  }
  window.dataLayer?.push(data)
}
